import {
  TApplicationReportActionType,
  TApplicationReportContent,
} from '~/components/ApplicationReports/types.ts';
import { applicationStatus } from '~/constants/directoryList.ts';

export const columnMenu = {
  columnMenuSortAsc: 'Сортувати за зростанням',
  columnMenuSortDesc: 'Сортувати за спаданням',
  columnMenuUnsort: 'Скасувати сортування',
  columnMenuFilter: 'Фільтр',
  columnMenuHideColumn: 'Приховати стовпець',
  columnMenuManageColumns: 'Керування стовпцями',
};

export enum SortField {
  status = 'STATUS',
  identificationNumber = 'IDENTIFICATION_NUMBER',
  createdAt = 'CREATED_AT',
  lastUpdatedAt = 'UPDATED_AT',
  initiator = 'MANAGER',
}

export const SORTABLE_FIELDS = [
  { field: 'status', label: 'Статус заявки' },
  { field: 'identificationNumber', label: 'РНОКПП або ЄДРПОУ' },
  { field: 'createdAt', label: 'Дата відкриття' },
  { field: 'lastUpdatedAt', label: 'Останні зміни в БД' },
  { field: 'initiator', label: 'Ініціатор заявки' },
];

export const APPLICATION_REPORT_ARCHIVE_STATUSES = new Set(['0', '3']);
export const APPLICATION_REPORT_RESTORE_STATUS = '7';
export const APPLICATION_REPORT_ACTIONABLE_STATUSES = new Set([
  ...APPLICATION_REPORT_ARCHIVE_STATUSES,
  APPLICATION_REPORT_RESTORE_STATUS,
]);

const normalizeApplicationReportStatus = (status: string | null | undefined) => {
  if (!status) {
    return null;
  }

  return (
    applicationStatus.find(
      (statusOption) => statusOption.value === status || statusOption.label === status
    )?.value ?? status
  );
};

export const getApplicationReportAction = (
  status: string | null | undefined
): TApplicationReportActionType | null => {
  const normalizedStatus = normalizeApplicationReportStatus(status);

  if (!normalizedStatus) {
    return null;
  }

  if (APPLICATION_REPORT_ARCHIVE_STATUSES.has(normalizedStatus)) {
    return 'archive';
  }

  if (normalizedStatus === APPLICATION_REPORT_RESTORE_STATUS) {
    return 'restore';
  }

  return null;
};

type TShouldShowApplicationReportActionColumnParams = {
  status: string | null | undefined;
  content?: Pick<TApplicationReportContent, 'status'>[] | null;
};

export const shouldShowApplicationReportActionColumn = ({
  status,
  content,
}: TShouldShowApplicationReportActionColumnParams) => {
  const normalizedStatus = normalizeApplicationReportStatus(status);

  if (normalizedStatus) {
    return APPLICATION_REPORT_ACTIONABLE_STATUSES.has(normalizedStatus);
  }

  return (content ?? []).some((row) => getApplicationReportAction(row.status) !== null);
};
